import { createClient } from '@supabase/supabase-js';

var SUPABASE_URL = 'https://cvdyjtadwcdzygrbftkb.supabase.co';
var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN2ZHlqdGFkd2NkenlncmJmdGtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0NTA3MDAsImV4cCI6MjA5MzAyNjcwMH0.0wHgMynLBwWRCvXdk_CBwpmZyqNdKksKV7OqStdTlAw';

export var supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);